export const alertConstants = {
    SUCCESS: 'success',
    ERROR: 'error',
    CLEAR: 'ALERT_CLEAR'
};